import { render, staticRenderFns } from "./buy.vue?vue&type=template&id=789366a4&scoped=true"
import script from "./buy.vue?vue&type=script&lang=js"
export * from "./buy.vue?vue&type=script&lang=js"
import style0 from "./buy.vue?vue&type=style&index=0&id=789366a4&prod&lang=scss"
import style1 from "./buy.vue?vue&type=style&index=1&id=789366a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789366a4",
  null
  
)

export default component.exports